import { type ReactNode } from 'react';
import Breadcrumb, { type Crumb } from '@/components/feature/Breadcrumb';

interface PageHeroProps {
  eyebrow: string;
  title: string;
  desc: string;
  crumbs: Crumb[];
  icon: string;
  children?: ReactNode;
}

export default function PageHero({ eyebrow, title, desc, crumbs, icon, children }: PageHeroProps) {
  return (
    <section className="w-full pt-28 md:pt-36 pb-10 md:pb-14 bg-background-100 border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <Breadcrumb items={crumbs} />
        <div className="mt-6 md:mt-8 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
              <i className={icon}></i>
              {eyebrow}
            </span>
            <h1 className="mt-4 text-3xl md:text-5xl text-foreground-950 leading-tight">{title}</h1>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl">{desc}</p>
          </div>
          {children}
        </div>
      </div>
    </section>
  );
}